module.exports = __webpack_public_path__ + "static/img/mag7.1a2e697.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/mag7.png
// module id = jsQk
// module chunks = 0